<template>

	<!-- Information Card 2 -->
	<a-card :bordered="false" class="card-info-2 h-full">
		<div class="col-content h-full">
			<!-- 纯 CSS 品牌盾牌图形（无库存照片，对齐客户端 CardInfo2） -->
			<div class="shield-art" aria-hidden="true">
				<svg viewBox="0 0 64 72" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M32 2 L60 12 V36 C60 54 48 66 32 70 C16 66 4 54 4 36 V12 Z"
						stroke="rgba(255,255,255,0.55)" stroke-width="2" />
					<path d="M32 18 L46 24 V38 C46 48 40 55 32 58 C24 55 18 48 18 38 V24 Z"
						fill="rgba(255,255,255,0.12)" stroke="rgba(255,255,255,0.4)" stroke-width="1.5" />
					<path d="M26 38 L30.5 43 L40 31" stroke="#ffffff" stroke-width="2.5"
						stroke-linecap="round" stroke-linejoin="round" />
				</svg>
			</div>
			<div class="card-content">
				<h5>Aegis-神盾 </h5>
				<p>为您出海业务保驾护航</p>
			</div>
		</div>
	</a-card>
	<!-- / Information Card 2 -->

</template>

<script>

	export default ({
		data() {
			return {
			}
		},
	})

</script>